import ItemShipping from './item-shipping';

export default class CalculateShipping {
  public cep?: string;
  public itens?: Array<ItemShipping>;
  public cartId?: number;
}
